"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CycleOwnerIdParams () {
        return CycleOwnerIdParams;
    },
    get GetSelectionManagersQueryParams () {
        return GetSelectionManagersQueryParams;
    },
    get UpdateCompensationCycleOwnersRequest () {
        return UpdateCompensationCycleOwnersRequest;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const UpdateCompensationCycleOwnersRequest = _zod.z.object({
    cycleOwnerIds: _zod.z.array(_utilsisomorphic.transformObjectId).max(1000, "Maximum number of cycle owners is 1,000")
});
const CycleOwnerIdParams = _zod.z.object({
    userId: _utilsisomorphic.transformObjectId
});
const GetSelectionManagersQueryParams = _zod.z.object({
    skip: _zod.z.coerce.number().min(0).default(0),
    limit: _zod.z.coerce.number().min(1).max(100).default(20),
    sortBy: _zod.z.enum([
        "name",
        "directReportCount",
        "totalCompensation"
    ]).default("name"),
    sortOrder: _zod.z.enum([
        "asc",
        "desc"
    ]).default("asc"),
    search: _zod.z.string().optional()
});
